import request from "axios"
import qs from "qs"

export default function localFetch(options) {
  Object.assign(options, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json; charset=UTF-8",
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  })

  return request(options)
}



// WEBPACK FOOTER //
// ./src/core/fetch.js